import * as React from 'react'
import styled from 'styled-components'
import { device } from '../../templates/displays/devices'
import Faded from '../../templates/animated/faded'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { INavigationItem } from 'shared-interfaces'
import DesktopDisplayOnly from '@/components/templates/displays/desktopDisplayOnly'
import Tooltip from '@/components/atoms/tooltip/tooltip'

const Wrapper = styled.div<IStyle>`
    width: 100%;
    height: 50px;
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    transition: all 100ms;
    background-color: white;
    z-index: 1;
    padding-bottom: ${(props) => (props.isScrollUp ? '10px' : '0px')};
`

const NavigationItem = styled.a<IStyle>`
    font-family: Lato;
    text-transform: uppercase;
    color: ${(props) =>
        props.ispageactive
            ? '#2a979a'
            : props.isDisabled
            ? '#A2A2A2'
            : 'black'};
    font-size: 14px;
    transition: all 300ms;
    padding-left: ${(props) => (props.index === 0 ? '0' : '1vw')};
    padding-right: 1vw;
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};

    @media ${device.smallest_laptops} {
        padding-left: 1vw;
        padding-right: 1vw;
    }
    @media ${device.ipad} {
        font-size: 13px;
        padding-left: ${(props) => (props.index === 0 ? '0px' : '1vw')};
        padding-right: 1vw;
    }

    :hover {
        color: ${(props) => (props.isDisabled ? '' : '#2a979a')};
    }
`

interface Props {
    navigation_data: INavigationItem[]
    isScrollUp: boolean
}

interface IStyle {
    ispageactive?: boolean
    index?: number
    isDisabled?: boolean
    isScrollUp?: boolean
}

const TopNavigationDesktop: React.FunctionComponent<Props> = (props) => {
    const { navigation_data, isScrollUp } = props

    const router = useRouter()

    let currentPath = router.asPath

    return (
        <DesktopDisplayOnly>
            <Wrapper isScrollUp={isScrollUp}>
                {navigation_data.map((navigationItem, index) => (
                    <Faded key={index}>
                        <Link
                            href={
                                navigationItem.disabled
                                    ? '#'
                                    : navigationItem.url
                            }
                            replace={true}
                            passHref
                        >
                            <NavigationItem
                                ispageactive={
                                    currentPath === navigationItem.url
                                }
                                index={index}
                                isDisabled={navigationItem.disabled}
                                data-attr={`${navigationItem.id}_desktop_nav_item`}
                            >
                                {navigationItem.disabled ? (
                                    <Tooltip text="Please request access from the owner">
                                        {navigationItem.pageName}
                                    </Tooltip>
                                ) : (
                                    navigationItem.pageName
                                )}
                            </NavigationItem>
                        </Link>
                    </Faded>
                ))}
            </Wrapper>
        </DesktopDisplayOnly>
    )
}

export default TopNavigationDesktop
